import { renderResearchText } from "@/components/ResearchText";

export const HsbcTable = ({ block, testId, children, headingLevel = 3 }) => {
  const Heading = `h${headingLevel}`;
  return <figure className="lvmh-data-table-figure hsbc-table-figure" data-testid={testId}>
    <figcaption id={`${testId}-caption`} data-testid={`${testId}-caption`}><Heading data-testid={`${testId}-heading`}>{block.caption}</Heading></figcaption>
    {children}
    <div className="lvmh-data-table-wrap hsbc-table-scroll" tabIndex={0} role="region" aria-labelledby={`${testId}-caption`} data-testid={`${testId}-scroll-region`}>
      <table aria-labelledby={`${testId}-caption`} data-testid={`${testId}-table`}>
        <thead><tr>{block.headers.map((header, index) => <th scope="col" key={header} data-testid={`${testId}-header-${index}`}>{header}</th>)}</tr></thead>
        <tbody>{block.rows.map((row, rowIndex) => <tr key={row[0]} className={["Group", "Total"].includes(row[0]) ? "is-total" : undefined} data-testid={`${testId}-row-${rowIndex}`}>
          {row.map((cell, cellIndex) => cellIndex === 0
            ? <th scope="row" key={cellIndex} data-testid={`${testId}-cell-${rowIndex}-${cellIndex}`}>{renderResearchText(cell, `${testId}-cell-${rowIndex}-${cellIndex}`)}</th>
            : <td key={cellIndex} data-testid={`${testId}-cell-${rowIndex}-${cellIndex}`}>{renderResearchText(cell, `${testId}-cell-${rowIndex}-${cellIndex}`)}</td>)}
        </tr>)}</tbody>
      </table>
    </div>
  </figure>;
};